<template>
  <v-dialog width="620" v-model="dialog" persistent scrollable>
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <v-toolbar-title>THÊM TỔ HỢP MÔN</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-6 py-0">
        <v-form v-bind="this.$attrs" ref="form">
          <div>
            <div class="pt-6">
              <div>
                <v-text-field
                  label="Tên tổ hợp"
                  v-model="room.name"
                  outlined
                  dense
                  required
                  :rules="[$rules.required]"
                  class="required"
                ></v-text-field>
              </div>
              <div>
                <v-select
                  label="Loại tổ hợp"
                  :items="typeOptions"
                  item-text="label"
                  item-value="value"
                  v-model="room.type"
                  outlined
                  dense
                  class="required"
                  :rules="[$rules.required]"
                ></v-select>
              </div>
              <div class="d-flex flex-wrap">
                <div
                  v-for="(subjectGroup, groupIndex) in groupedSubjects"
                  :key="groupIndex"
                  class="d-flex"
                  style="width: 100%"
                >
                  <div class="d-flex" style="width: 100%">
                    <v-checkbox
                      v-for="(subject, subjectIndex) in subjectGroup"
                      :key="subjectIndex"
                      v-model="selectedSubjects"
                      :value="subject.id"
                      :label="subject.name"
                      class="pt-0 mt-0 pb-6"
                      hide-details
                      style="flex-basis: 33%"
                    ></v-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-form>
      </v-card-text>

      <v-divider> </v-divider>
      <v-card-actions class="pa-6">
        <v-btn color="blue darken-4" outlined @click="close">Hủy </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-4" dark @click="submit">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { chunk } from 'lodash'
export default {
  props: {
    state: Boolean,
    subjects: Array
  },
  watch: {
    state(state) {
      this.dialog = state
      if (!state) this.loading = false
    }
  },
  computed: {
    groupedSubjects() {
      return chunk(this.subjects, 3)
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      selectedSubjects: [],
      room: {
        name: '',
        type: '',
        subjects: [],
        exam: this.$route.params.id
      },
      typeOptions: [
        { label: 'Cơ bản', value: 'basic' },
        { label: 'Tiên tiến', value: 'advanced' }
      ]
    }
  },
  methods: {
    ...mapActions('subjectExamGroup', ['createSubjectGroup']),
    close() {
      this.$emit('closeDialog')
      this.$refs.form.resetValidation()
    },

    handleCheckboxChange(room, subject) {
      const index = room.subjects.findIndex(s => s.id === subject.id)
      if (index >= 0) {
        room.subjects.splice(index, 1)
      } else {
        room.subjects.push(subject)
      }
    },

    resetForm() {
      this.room = {
        name: '',
        type: '',
        subjects: [],
        exam: this.$route.params.id
      }
      this.selectedSubjects = []
    },
    async submit() {
      if (this.$refs.form.validate()) {
        this.$loading.active = true
        const roomData = this.room
        roomData.subjects = this.selectedSubjects
        const updatedRoom = await this.createSubjectGroup({ ...roomData })
        if (updatedRoom) {
          this.$emit('refresh')
          this.resetForm()
          this.close()
        }
      }
    }
  }
}
</script>
